module.exports = __webpack_public_path__ + "static/img/ljjt.85f9bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/ljjt.png
// module id = i4gl
// module chunks = 1